/** Enum option arrays — must match backend enum values exactly. */
// COPY LOCKED — do not paraphrase labels without client confirmation. See /app/memory/PRD.md.

export const PROPERTY_STATUS_OPTIONS = [
    { value: "own", label: "I own the property" },
    { value: "recently_purchased", label: "I recently purchased the property" },
    { value: "currently_purchasing", label: "I am currently purchasing the property" },
];

export const PROJECT_TYPE_OPTIONS = [
    { value: "rear_extension", label: "Rear extension" },
    { value: "side_extension", label: "Side extension" },
    { value: "loft", label: "Loft conversion / extension" },
    { value: "internal_reconfiguration", label: "Internal reconfiguration" },
    { value: "combination", label: "Combination of the above" },
    { value: "other", label: "Other" },
];

// `label_compact` — abbreviated form used by the Projects list Budget
// column AND the Projects sidebar Budget filter chips (single-source).
// The canonical `label` remains the verbose form used by the enquiry
// form, EnquiryDetail, workspace, etc.  British English, en dash on
// ranges, single `£` on ranges to match the historical filter pill
// wording that operators are already familiar with.
export const BUDGET_OPTIONS = [
    { value: "under_100k", label: "Under £100,000", label_compact: "Under £100k" },
    { value: "100_150k", label: "£100,000–£150,000", label_compact: "£100–150k" },
    { value: "150_250k", label: "£150,000–£250,000", label_compact: "£150–250k" },
    { value: "250k_plus", label: "£250,000+", label_compact: "£250k+" },
    { value: "guidance", label: "Would like guidance", label_compact: "Need guidance" },
];

export const TIMING_OPTIONS = [
    { value: "asap", label: "As soon as possible" },
    { value: "within_3m", label: "Within 3 months" },
    { value: "3_6m", label: "3–6 months" },
    { value: "6_12m", label: "6–12 months" },
    { value: "more_than_12m", label: "More than 12 months" },
];

/** UK postcode — loose pattern used as a soft warning only. */
export const UK_POSTCODE_RE = /^[A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}$/i;
